import {Injectable} from '@angular/core';
import {AuthHttpService} from '../core/auth-http.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import { catchError } from 'rxjs/operators'
import moment from 'moment';
import { HttpErrorResponse } from '@angular/common/http';
import { LocationCollection } from './location-collections';

@Injectable()
export class LocationCollectionsService {
  constructor(private http: AuthHttpService) {}

  list(): Observable<any> {
    return this.http.getV3(`${environment.apiv3url}/location_collections`).pipe(
      catchError((error: HttpErrorResponse) => this.http.handleError(error)));
  }

  create(locationCollection: LocationCollection): Observable<LocationCollection | string> {
    return this.http.postV3<LocationCollection>(`${environment.apiv3url}/location_collections`, locationCollection).pipe(
      catchError((error: HttpErrorResponse) => this.http.handleError(error)));
  }

  get(id): Observable<any> {
    return this.http.getV3(`${environment.apiv3url}/location_collections/:id`.replace(':id', id)).pipe(
      catchError((error: HttpErrorResponse) => this.http.handleError(error)));
  }

  delete(id): Observable<any> {
    return this.http.deleteV3(`${environment.apiv3url}/location_collections/:id`.replace(':id', id)).pipe(
      catchError((error: HttpErrorResponse) => this.http.handleError(error)));
  }

  update(locationCollection: LocationCollection): Observable<LocationCollection | string> {
    return this.http.updateV3<LocationCollection>(`${environment.apiv3url}/location_collections/:id`.replace(':id', locationCollection.id), locationCollection).pipe(
      catchError((error: HttpErrorResponse) => this.http.handleError(error)));
  }

  formatLocationCollection(locationCollection: LocationCollection) {
    locationCollection['created_at'] = moment(locationCollection['created_at'] as string).format('LLL');
  }

  formatData(locationCollections) {
    const data = locationCollections.location_collections;
    data.forEach(locationCollection => {
      this.formatLocationCollection(locationCollection);
    });
    return data;
  }
}
